import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import ActionBar from "../../../Components/Button/ActionBar";
import SeatPlanForm from "../../../Components/Forms/SeatPlanForm";
import Delete from "../../../Components/Button/Delete";

interface Item {
  ticket_id: number;
  ticket_group_code: string;
  // Add more properties as per your item structure
}

export default function SeatPlan() {
  const location = useLocation();
  const id = location.state && location.state.id;
  const [image, setImage] = useState<File[]>([]);
  const [ticket_group_code, setTicketGroupCode] = useState("");
  const [items, setItems] = useState<Item[]>([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [postID, setPostID] = useState<string | null>(null);
  const [role, setRole] = useState<string | null>(null);
  const [warningMessage, setWarningMessage] = useState<string>("");
  const isMounted = useRef(false);

  const MAX_FILE_SIZE_MB = 30;

  useEffect(() => {
    const id = location.state && location.state.id;
  }, [id]);

  const handleChangeTicketGroupCode = (
    e: React.ChangeEvent<HTMLSelectElement>
  ) => {
    setTicketGroupCode(e.target.value);
  };

  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      const selectedFiles = Array.from(e.target.files);
      const totalSize = selectedFiles.reduce(
        (total, file) => total + file.size,
        0
      );

      // Convert total size to MB
      const totalSizeInMB = totalSize / (1024 * 1024);

      // Check if the total size exceeds the limit
      if (totalSizeInMB > MAX_FILE_SIZE_MB) {
        setWarningMessage(
          `Warning: You can only upload up to ${MAX_FILE_SIZE_MB} MB of images. The selected files exceed this limit.`
        );
      } else {
        setWarningMessage("");
        setImage(selectedFiles);
      }
    }
  };

  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);

    const formData = new FormData();
    formData.append("ticket_group_code", ticket_group_code);
    if (image.length > 0) {
      image.forEach((image, index) => {
        formData.append(`image[${index}]`, image);
      });
    }

    try {
      const authToken = localStorage.getItem("authToken");
      if (!authToken) {
        alert("Authentication token not found!");
        setIsSubmitting(false);
        return;
      }

      if (postID) {
        await axios.post(
          `https://stagingbackend.pulp.ph/v1/pulpliveworld/seatPlan/${postID}`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
      } else {
        const response = await axios.post(
          `https://stagingbackend.pulp.ph/api/v1/pulpliveworld/seatPlan`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        setPostID(response.data.id);
      }
      alert("Content Submitted Successfully !!");
      navigate("/view/post/seat-plan");
    } catch (error) {
      console.error("There was an error submitting the form!", error);
      alert(`All fields required`);
    } finally {
      setTimeout(() => {
        setIsSubmitting(false);
      }, 3000);
    }
  };

  useEffect(() => {
    const storedRole = localStorage.getItem("role");
    setRole(storedRole);
  }, [role]);

  useEffect(() => {
    isMounted.current = true;
    const fetchData = async () => {
      try {
        const response = await axios.get(
          "https://stagingbackend.pulp.ph/api/v1/pulpliveworld/ticket",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            },
          }
        );
        if (isMounted.current) {
          setItems(response.data.ticket);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
    return () => {
      isMounted.current = false;
    };
  }, [items]);

  const handleDelete = async () => {
    try {
      const authToken = localStorage.getItem("authToken");
      if (!authToken) {
        // Handle the case where authToken is not available
        alert("Authentication token not found!");
        return;
      }

      const confirmDelete = window.confirm(
        "Are you sure you want to delete this content?"
      );
      if (!confirmDelete) {
        return; // If user cancels, do nothing
      }

      if (id) {
        await axios.delete(
          `https://stagingbackend.pulp.ph/api/v1/pulpliveworld/seatPlan/${id}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            },
          }
        );
      }
      alert("Content Deleted Successfully !!"); // Handle success (e.g., show a success message or redirect)
      navigate("/view/post/Show");
    } catch (error) {
      console.error("There was an error submitting the form!", error);
      // Handle error (e.g., show an error message)
    }
  };

  return (
    <>
      <div className="w-full">
        <div className="Dashboard-container flex place-content-between">
          <h1 className="mt-5 font-semibold">seatPlan Editor</h1>
          <ActionBar
            role={role}
            // onSave={handleSaveDraft}
            onSubmit={handleSubmit}
            isSubmitting={isSubmitting}
            isSaved={isSubmitting}
          />
        </div>
        <div className="container mt-5 pt-5 px-4 rounded bg-white">
          <SeatPlanForm
            image={image}
            items={items}
            ticket_group_code={ticket_group_code}
            warningMessage={warningMessage}
            onTicketGroupCodeChange={handleChangeTicketGroupCode}
            onImageChange={handleImageChange}
          />
          <div className="w-full border-1 border-black rounded mb-5"> </div>
          <Delete onDelete={handleDelete} />
          {/* onClick={() => handleDelete(item.id)} */}
        </div>
      </div>
    </>
  );
}
